import { defineComponent as _defineComponent } from 'vue'
import ShareQuoteDialogV1 from '@/components/ShareQuoteDialogV1.vue'
import ShareQuoteDialogV2 from '@/components/ShareQuoteDialogV2.vue'
import { useSplit } from '@/composables/useSplit'
import { SplitFeatureFlag } from '@/utils/enum'
import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ShareQuoteDialog',
  props: {
    quoteId: null
  },
  setup(__props: any) {

const props = __props as {
  quoteId: number
};



const { isFeatureEnabled } = useSplit()
const isUserRoleManagementEnabled = ref(false)

onMounted(async () => {
  isUserRoleManagementEnabled.value = await isFeatureEnabled(SplitFeatureFlag.UserRoleManagement)
})

return { __sfc: true,props, isFeatureEnabled, isUserRoleManagementEnabled, ShareQuoteDialogV1, ShareQuoteDialogV2 }
}

})